import { VoidFunctionComponent } from 'react'
import Button from 'components/button'

import { useHistory } from 'react-router-dom'
import textServices from 'services/text-services'
import { TriviaItem } from '../types'
import { ButtonMenu, SpanMenu } from '../../../theme/header'
import { DivModalContinue, ButtonModalContinue, TriviaModalH1, TriviaModelP, TriviaModalWarning} from '../../../theme/trivias'

export interface TriviaModalProps {
  trivia: TriviaItem
  onAccept: () => void
}

const TriviaModal: VoidFunctionComponent<TriviaModalProps> = ({ trivia, onAccept }) => {
  const history = useHistory()

  return (
    <DivModalContinue className="flex flex-col w-full p-8 absolute top-0 min-h-screen h-screen">
      <ButtonMenu className="h-24 w-24 absolute right-0 top-0 p-8" onClick={history.goBack} open={true}>
        <SpanMenu open={true} className="transition block h-0.5 w-8 transform rotate-45 -mb-0.5" />
        <SpanMenu open={true} className="transition block h-0.5 w-8 transform -rotate-45 -mb-0.5" />
      </ButtonMenu>
      <div className="flex-1 flex items-center justify-center flex-col gap-4">
        <TriviaModalH1 className="uppercase text-3xl text-center font-bold">{trivia?.name}</TriviaModalH1>
        <TriviaModelP className="din text-center">
          {trivia.costInPoints > 0 && (
            <>Estás a punto de canjear {trivia.costInPoints} {POINTS_NAME} para participar en esta trivia y ganar:</>
          )}
          {trivia.costInPoints === 0 && (
            <>Estás a punto de participar en esta trivia y ganar:</>
          )}
          <b> {trivia.prize}</b>
        </TriviaModelP>
        <TriviaModalWarning className="din text-center">
          {textServices.findByText('tivias/challenge/modal/description', '¿Segurísimo que quieres jugarla? Recuerda que una vez que des clic no hay vuelta atrás.')}
        </TriviaModalWarning>
      </div>

      <div className="flex justify-center flex-col">
        <Button onClick={onAccept}>
          {textServices.findByText('tivias/challenge/modal/button', 'Sí, claro')}
        </Button>

        <ButtonModalContinue className="uppercase underline text-xs din text-center mt-4" onClick={history.goBack}>
          {textServices.findByText('tivias/challenge/modal/back', 'No, volver')}
        </ButtonModalContinue>
      </div>
    </DivModalContinue>
  )
}

export default TriviaModal
